import { createRoot } from 'react-dom/client'
import './styles.css'
import { Logo } from '@pmndrs/branding'
import { App } from './App'

function Root() {
  return (
    <>
      <App />
      <div style={{ position: 'absolute', zIndex: '-1', pointerEvents: 'none', top: 0, left: 0, width: '100vw', height: '100vh', background: 'url(./background.jpg) no-repeat center/cover' }}>
      </div>
      <div style={{ position: 'absolute', pointerEvents: 'none', top: 0, left: 0, width: '100vw', height: '100vh' }}>
        <div className="header" style={{ position: 'absolute', top: 20, paddingLeft: 10, width: 'calc(100% - 50px)', display: 'flex', justifyContent: 'space-between' }}>
          <a href="https://www.supducks.com/" target="_blank"><img src="./logo.png" /></a>
          <div className="social-buttons" style={{ display: 'flex', flexDirection: 'row', gap: 16 }}>
            <a href="https://discord.gg/supducks" target="_blank"><img src="./discord_icon.png" /></a>
            <a href="https://twitter.com/SupDucks" target="_blank"><img src="./twitter_icon.png" /></a>
          </div>
        </div>
        <div className="footer" style={{ position: 'fixed', bottom: 14, padding: '0 20px', width: 'calc(100% - 80px)', display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
          <span style={{ color: 'white', fontSize: '14px', fontDisplay: 'bold', textShadow: '0 0 10px black' }}>
            <a href="https://opensea.io/collection/da-squish" target="_blank"><b>OpenSea</b></a> • 
            <a href="https://shop.supducks.com" target="_blank"><b>Shop</b></a> • 
            Built by MegaVoltCorp, All Rights Reserved © 2024 : 
            <a href="https://basescan.org/address/0x0ddfe6192282b96d545366bb7a81075e60a0fbb1" target="_blank">0x0ddfe6192282b96d545366bb7a81075e60a0fbb1</a>
          </span>
        </div>
      </div>
    </>
  )
}

createRoot(document.getElementById('root')).render(<Root />)
